module.exports = __webpack_public_path__ + "img/cover-7.ecd9b7ad.jpg";